import moment from "moment";

export function nextOccurrenceCell(data) {
  if (data.nextOccurrence) {
    return "Next: " + moment(data.nextOccurrence).format("MMM D");
  }

  const schedules = data.schedules || data.schedulars || [];
  return schedules.length > 0 ? "Ended" : "—";
}

export function recurringMarkerCell(data) {
  return data.recurring_id
    ? '<i class="pi pi-refresh text-500" title="Generated from a recurring schedule"></i>'
    : "";
}

// domain -> { label, route } for the record types a Schedular can target.
export const SCHEDULAR_TARGET_TYPES = {
  301: { label: "Invoice", route: "invoice-builders" },
  190: { label: "Event", route: "events" },
  174: { label: "Journal Entry", route: "journal-entries" },
};

export function getTargetType(domain) {
  return SCHEDULAR_TARGET_TYPES[Number(domain)] || null;
}

export function getTargetLabel(domain, target) {
  if (!target) return "";

  switch (Number(domain)) {
    case 301:
      return target.display_name || "";
    case 190:
      return target.title || "";
    case 174:
      return target.is_template === 1
        ? target.template_name || target.number || ""
        : target.number || "";
    default:
      return target.display_name || target.title || target.number || "";
  }
}

export function targetCell(data) {
  if (!data.object_id) return "";

  const type = getTargetType(data.domain);
  const typeLabel = type ? type.label : "";

  if (!data.target) {
    return '<span class="text-orange-500"><i class="pi pi-exclamation-triangle mr-1"></i>Target not found</span>';
  }

  const label = getTargetLabel(data.domain, data.target) || "(untitled)";
  const badge = typeLabel ? `<span class="text-500 text-xs mr-1">[${typeLabel}]</span>` : "";
  return badge + label;
}
